module.exports = __webpack_public_path__ + "static/media/git.bb72462e.svg";